
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalSelectGrid extends _Ext.GridBase<POSApprovalItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalItems'; }
        protected getDialogType() { return POSApprovalItemsDialog; }
        protected getIdProperty() { return POSApprovalItemsRow.idProperty; }
        //protected getInsertPermission() { return POSReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalItemsRow.localTextPrefix; }
        protected getService() { return POSApprovalSelectItemsService.baseUrl; } 
        protected getInitialTitle() { return null; };
        private autoSize;
        constructor(container: JQuery, options) {
            super(container, options);
            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = (options.GridFilters as _Ext.SelectGridFilters).CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                request.POSCustomerId = poscustomerid; 

            }
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): POSReturnRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;

            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}